import { render, staticRenderFns } from "./DesignComment.vue?vue&type=template&id=9e749ee2&scoped=true&"
import script from "./DesignComment.vue?vue&type=script&lang=js&"
export * from "./DesignComment.vue?vue&type=script&lang=js&"
import style0 from "./DesignComment.vue?vue&type=style&index=0&id=9e749ee2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e749ee2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e749ee2')) {
      api.createRecord('9e749ee2', component.options)
    } else {
      api.reload('9e749ee2', component.options)
    }
    module.hot.accept("./DesignComment.vue?vue&type=template&id=9e749ee2&scoped=true&", function () {
      api.rerender('9e749ee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/submissions/DesignComment.vue"
export default component.exports